import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {Router} from '@angular/router';
import {AuthService} from '@app/auth/auth.service';
import {SiteConfigService} from '@app/shared/site-config.service';
import {StorageService} from '@app/shared/storage.service';
import {Observable} from 'rxjs';
import {filter, switchMap, take, tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {FooterComponent} from '../footer/footer.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {TryBlockComponent} from '../try-block/try-block.component';

@Component({
    selector: 'frog-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    imports: [ToolbarComponent, MatButton, MatIcon, TryBlockComponent, FooterComponent, AsyncPipe],
})
export class LandingComponent implements OnInit {
    public user$: Observable<any>;
    public hosted = environment.hosted;
    public hostname: string;

    constructor(
        private authService: AuthService,
        private storageService: StorageService,
        private siteConfigService: SiteConfigService,
        private router: Router,
    ) {
        this.hostname = window.location.hostname;
    }

    ngOnInit(): void {
        const token = this.storageService.get('token');
        if (token !== null) {
            this.authService.login(token).subscribe();
        }

        this.user$ = this.authService.user.pipe(
            filter(Boolean),
            switchMap(() => this.siteConfigService.siteConfig),
            filter((config) => Boolean(config.data)),
            take(1),
            tap((config) => {
                this.router.navigate(['/s', config.data.primary_stream]);
            }),
        );
    }

    login(signup: boolean) {
        this.storageService.set('signup', signup);
        this.authService.redirectToIdp();
    }
}
